/**
 * Password policy mirrored from
 * cosmo-bud-portal-backend/src/modules/auth/dto/change-password.dto.ts.
 * Used for client-side hints; the backend Zod schema is still authoritative.
 */
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 256;

export interface PasswordCheck {
  ok: boolean;
  reason?: string;
}

export function checkNewPassword(currentPassword: string, newPassword: string): PasswordCheck {
  if (newPassword.length < PASSWORD_MIN_LENGTH) {
    return {
      ok: false,
      reason: `New password must be at least ${PASSWORD_MIN_LENGTH} characters`,
    };
  }
  if (newPassword.length > PASSWORD_MAX_LENGTH) {
    return {
      ok: false,
      reason: `New password must be at most ${PASSWORD_MAX_LENGTH} characters`,
    };
  }
  if (currentPassword === newPassword) {
    return { ok: false, reason: 'New password must differ from the current password' };
  }
  return { ok: true };
}
